import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { useLocation } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import logo from "../image/logonexus.png"; 
import { createGlobalStyle } from "styled-components";

// Override Ant Design's modal styles
const GlobalStyle = createGlobalStyle`
  .ant-modal-content {
    background: linear-gradient(90deg, rgb(3, 13, 51), rgb(0, 53, 55), rgb(0 0 0)) !important; /* Dark background */
    color: white !important; /* White text */
    border-radius: 12px !important;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2) !important;
  }
`;

const WelcomeMessage = () => {
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (location.pathname === "/") {
            const hasVisited = sessionStorage.getItem("hasVisited");
            if (!hasVisited) {
                setIsVisible(true);
                sessionStorage.setItem("hasVisited", "true");
            }
        }
    }, [location.pathname]);

    return (
        <>
            <GlobalStyle /> {/* Inject global styles */}
            <Modal
                open={isVisible}
                onCancel={() => setIsVisible(false)}
                footer={null}
                centered
                width={500}
                closeIcon={<CloseOutlined style={{ color: "#fff", fontSize: "18px" }} />}
            >
                <div style={{ textAlign: "center", padding: "20px" }}>
                    <img src={logo} alt="Company Logo" style={{ width: "100px", marginBottom: "15px" }} />
                    <h2 style={{ color: "#4ACFAC", fontSize: "22px", fontWeight: "700" }}>
                        🚀 Welcome to Nexus Wealth Services
                    </h2>
                    <p style={{fontSize: "15px", lineHeight: "1.6", maxWidth: "350px", opacity: "0.9" }}>
                        Transforming <strong>Hotel, Textile, Real Estate & Export-Import Industry,  </strong> with 
                        <strong> Innovation & Excellence.</strong>  
                        Your success is our priority! 🌍✨
                    </p>
                </div>
            </Modal>
        </>
    );
};

export default WelcomeMessage;
